export const PROJECT_KIND = {
  fullstack: 'fullstack',
  frontend: 'frontend',
  backend: 'backend',
};

